import { InquiryData } from '../../models/InquiryData';
import BaseApi from './BaseApi';

type ChatMessagesList = {
  chatObject: {
    inquiryData: InquiryData[];
    chatMessageList: {
      /**
       * メッセージの送信方向
       * 0: ユーザー -> 加盟店
       * 1: 加盟店 -> ユーザー
       * 2: System -> ユーザー
       */
      sendingDirection: '0' | '1' | '2' | '3';
      sendStaffId: string;
      alreadyReadFlg: boolean;
      message?: string;
      image?: string;
      chatId: string;
      inquiryDataMatchId?: string;
      date: number;
    }[];
  };
  isReceived: boolean;
  /**
   * メッセージの送信方向
   * 0: ユーザー -> 加盟店
   * 1: 加盟店 -> ユーザー
   * 2: System -> ユーザー
   */
  status: 0 | 1 | 2;
};

/**
 * LINE問い合わせチャット詳細取得API。
 */
class GetKaiinChatLineChatListApi extends BaseApi {
  async get(matchId: string) {
    return await this.execute('getKaiinChatLineChatListApi', {
      method: 'POST',
      body: {
        matchId
      }
    }).then(({ result }) => result as ChatMessagesList);
  }
}

export default GetKaiinChatLineChatListApi;
